// // src/app/interceptors/auth.interceptor.ts
// import { Injectable } from '@angular/core';
// import {
//   HttpRequest,
//   HttpHandler,
//   HttpEvent,
//   HttpInterceptor,
//   HttpErrorResponse,
// } from '@angular/common/http';
// import { Observable, throwError } from 'rxjs';
// import { catchError } from 'rxjs/operators';
// import { Router } from '@angular/router';
// import { ToastService } from './toast.service';

// @Injectable()
// export class AuthInterceptor implements HttpInterceptor {
//   constructor(private router: Router, private toast: ToastService) {}

//   intercept(
//     req: HttpRequest<any>,
//     next: HttpHandler
//   ): Observable<HttpEvent<any>> {
//     return next.handle(req).pipe(
//       catchError((err: HttpErrorResponse) => {
//         // Only handle session-level errors (not form validation 400s etc.)
//         if (err.status === 401) {
//           const code = err.error?.code as string | undefined;

//           let msg = 'Your session has expired. Please log in again.';

//           if (code === 'SESSION_REPLACED') {
//             msg =
//               'You were signed in from another device. This session has ended.';
//           } else if (code === 'SESSION_INACTIVE') {
//             msg =
//               'You were logged out after 3 hours of inactivity.';
//           } else if (code === 'TOKEN_EXPIRED') {
//             msg = 'Your session has expired. Please log in again.';
//           } else if (err.error?.message) {
//             msg = err.error.message;
//           }

//           this.clearLocalSession();
//           this.toast.showError(msg);

//           // Small delay so toast is visible before navigation
//           setTimeout(() => this.router.navigate(['/login']), 300);
//         }

//         return throwError(() => err);
//       })
//     );
//   }

//   private clearLocalSession(): void {
//     ['authToken', 'userId', 'email', 'name', 'role', 'packageId'].forEach(
//       (k) => localStorage.removeItem(k)
//     );
//   }
// }






// auth.intercepter.ts
import { Injectable } from '@angular/core';
import {
  HttpRequest, HttpHandler, HttpEvent,
  HttpInterceptor, HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastService } from './toast.service';
import { SessionModalService } from './session-modal.service';

const SESSION_INFO_CODES = new Set(['SESSION_REPLACED', 'SESSION_INACTIVE']);

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private toast: ToastService,
    private sessionModal: SessionModalService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          const code = err.error?.code as string | undefined;
          const msg  = err.error?.message || 'Your session has expired. Please log in again.';

          this.clearLocalSession();

          if (code && SESSION_INFO_CODES.has(code)) {
            // Show friendly modal — navigate happens inside the modal's button
            this.sessionModal.show({
              code: code as 'SESSION_REPLACED' | 'SESSION_INACTIVE',
              message: msg
            });
          } else {
            // Regular errors → existing toast
            this.toast.showError(msg);
            setTimeout(() => this.router.navigate(['/login']), 300);
          }
        }

        return throwError(() => err);
      })
    );
  }

  private clearLocalSession(): void {
    ['authToken', 'userId', 'email', 'name', 'role', 'packageId']
      .forEach(k => localStorage.removeItem(k));
  }
}